<template>
  <v-footer class="mt-16 mb-8 pb-8" color="transparent">
    <v-container>
      <v-row>
        <v-col v-for="item in items" :key="item.header" cols="12" md="4">
          <v-card
            min-height="100%"
            class="d-flex align-center justify-center footer-card"
            elevation="8"
            hover
          >
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="4" md="12" lg="4" align="center">
                  <v-avatar color="primary" size="72" class="footer-icon">
                    <v-icon dark color="white" size="40">
                      {{ item.icon }}
                    </v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="8" md="12" lg="8" :class="{'text-center': $vuetify.breakpoint.mdOnly}">
                  <div class="font-weight-bold text-h6 mb-2 primary--text">
                    {{ item.header }}
                  </div>
                  <div class="text-body-1 grey--text text--darken-1">
                    {{ item.subTitle }}
                  </div>
                  <template v-if="item.subTitle2">
                    <div class="text-h6 font-weight-bold accent--text mt-2">
                      <a v-if="item.isPhoneLink" href="tel:818-429-2924" class="text-decoration-none accent--text">
                        {{ item.subTitle2 }}
                      </a>
                      <span v-else>{{ item.subTitle2 }}</span>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      items: [
        {
          icon: 'mdi-phone-classic',
          header: 'Free Estimates',
          subTitle: 'Call today to get your free estimate!',
          subTitle2: '(818) 429-2924',
          isPhoneLink: true,
        },
        {
          icon: 'mdi-briefcase-check',
          header: 'Experience You Need',
          subTitle: 'With over 30 years of experience, you can be sure the job is done right the first time.',
        },
        {
          icon: 'mdi-account-hard-hat',
          header: 'The Service You Expect',
          subTitle: 'Reliable, quality service for all your home remodel and restoration needs.',
        }
      ]
    }
  }
}
</script>

<style scoped>
.footer-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  background: white;
}

.footer-card:hover {
  transform: translateY(-4px);
}

.footer-icon {
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);
}

.footer-card:hover .footer-icon {
  transform: scale(1.1);
  box-shadow: 0 6px 12px rgba(25, 118, 210, 0.4);
}
</style>
